import { render } from "./CaseViewerID.vue?vue&type=template&id=3d50fd4e&scoped=true"
import script from "./CaseViewerID.vue?vue&type=script&lang=js"
export * from "./CaseViewerID.vue?vue&type=script&lang=js"

import "./CaseViewerID.vue?vue&type=style&index=0&id=3d50fd4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d50fd4e"]])

export default __exports__